var map = {
	"./HelveticaNeueCyr-Black.woff2": 247,
	"./HelveticaNeueCyr-Bold.woff2": 248,
	"./HelveticaNeueCyr-ExtraBold.woff2": 249,
	"./HelveticaNeueCyr-Light.woff2": 250,
	"./HelveticaNeueCyr-Medium.woff2": 251,
	"./HelveticaNeueCyr-Regular.woff2": 252,
	"./HelveticaNeueCyr-Thin.woff2": 253,
	"./HelveticaNeueCyr-UltraLight.woff2": 254
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 246;